export { Errata };
/**
 * Отчёт об ошибке.
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
class Errata {
  /**
   * Код состояния HTTP.
   * @type {int}
   * @see [Список](https://ru.wikipedia.org/wiki/Список_кодов_состояния_HTTP)
   */
  http_status = 0;

  /**
   * Тип ошибки.
   * @type {"auth"|"schema"|"other"|"ajax"}
   */
  error_type = "ajax";

  /**
   * Массив сообщений об ошибках.
   * @type {string[]}
   */
  errors = [MSG["NO_ERRATA_ERRORS"]];

  /**
   * Действие для повторной отправки запроса.
   * @type {function?}
   * @example
   * errata.retry();
   */
  retry;

  /**
   * Копирует свойства объекта с валидацией.
   * @param {Object} properties - свойства объекта.
   */
  constructor(properties) {
    Object.assign(this, properties);
  }
}
// Локализованные сообщения
const MSG =
{
  NO_ERRATA_ERRORS: "Сообщение об ошибке не указано."
};
